import React from "react";

const LoadingSpinner: React.FC = () => (
  <div className="space-y-4 mx-auto flex w-full">
    <div className="inset-y-0 right-6 flex items-center mx-auto w-full justify-center">
      <div className="w-7 h-7 border-4 border-gray-200 border-t-[#044E97] rounded-full animate-spin"></div>
    </div>
  </div>
);

export default LoadingSpinner;
